import { render, staticRenderFns } from "./PositionSearch.vue?vue&type=template&id=8870f830&"
import script from "./PositionSearch.vue?vue&type=script&lang=js&"
export * from "./PositionSearch.vue?vue&type=script&lang=js&"
import style0 from "./PositionSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
